import { Transition } from 'motion/react';

export const bounceTransition: Transition = {
  type: 'spring',
  duration: 0.4,
  bounce: 0.2,
  delayChildren: 1000,
};
